import { createSlice } from "@reduxjs/toolkit";
const initialState ={
    payments:[],
    loading:false
}

const paymentSlice = createSlice({
    name:"payment",
    initialState: initialState,
    reducers: {
        setPayment(state, value) {
            state.payments = value.payload;
        },
        setLoading(state, value) {
            state.loading = value.payload;
          },
    },
});

export const {setPayment, setLoading} = paymentSlice.actions;
export default paymentSlice.reducer;